<div class="spacing--margin-horizontal spacing--margin-top">
  <form [formGroup]="form">
    <div class="spacing--margin-bottom extended-baseline-settings">
      <span class="text--small text--h5 label">
        {{ 'feed-profit.settings.extended-baseline-settings.title' | translate }}
      </span>
      <div class="flex--column spacing--margin-top">
        <mat-form-field class="flex__child--auto">
          <mat-label>{{
            'feed-profit.settings.extended-baseline-settings.squareMeterPerGrowFinisher' | translate
          }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="0.01"
            placeholder="{{
              'feed-profit.settings.extended-baseline-settings.squareMeterPerGrowFinisher'
                | translate
            }}"
            data-test="feedprofit-settings__squareMeterPerGrowFinisher"
            formControlName="squareMeterPerGrowFinisher"
          />
        </mat-form-field>
        <mat-form-field class="flex__child--auto">
          <mat-label>{{
            'feed-profit.settings.extended-baseline-settings.startWeight' | translate
          }}</mat-label>
          <input
            type="number"
            matInput
            agrNumber
            [step]="0.01"
            placeholder="{{
              'feed-profit.settings.extended-baseline-settings.startWeight' | translate
            }}"
            data-test="feedprofit-settings__startWeight"
            formControlName="startWeight"
          />
        </mat-form-field>
        <mat-form-field class="flex__child--auto">
          <span matTextPrefix class="spacing--padding-half-right">{{ currencySymbol }}</span>
          <mat-label>{{
            'feed-profit.settings.extended-baseline-settings.growFinisherPrice' | translate
          }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="0.01"
            placeholder="{{
              'feed-profit.settings.extended-baseline-settings.growFinisherPrice' | translate
            }}"
            data-test="feedprofit-settings__growFinisherPrice"
            formControlName="growFinisherPrice"
          />
        </mat-form-field>
        <mat-form-field class="flex__child--auto">
          <span matTextPrefix class="spacing--padding-half-right">{{ currencySymbol }}</span>
          <mat-label>{{
            'feed-profit.settings.extended-baseline-settings.revenuePerKg' | translate
          }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="0.01"
            placeholder="{{
              'feed-profit.settings.extended-baseline-settings.revenuePerKg' | translate
            }}"
            data-test="feedprofit-settings__revenuePerKg"
            formControlName="revenuePerKg"
          />
        </mat-form-field>
        <mat-form-field class="flex__child--auto">
          <mat-label>{{
            'feed-profit.settings.extended-baseline-settings.slaughteredWeightInKg' | translate
          }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="0.01"
            placeholder="{{
              'feed-profit.settings.extended-baseline-settings.slaughteredWeightInKg' | translate
            }}"
            data-test="feedprofit-settings__slaughteredWeightInKg"
            formControlName="slaughteredWeightInKg"
          />
        </mat-form-field>
        <mat-form-field class="flex__child--auto">
          <mat-label>{{
            'feed-profit.settings.extended-baseline-settings.meatPercentage' | translate
          }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="0.01"
            placeholder="{{
              'feed-profit.settings.extended-baseline-settings.meatPercentage' | translate
            }}"
            data-test="feedprofit-settings__meatPercentage"
            formControlName="meatPercentage"
          />
        </mat-form-field>
        <mat-form-field class="flex__child--auto">
          <mat-label>{{
            'feed-profit.settings.extended-baseline-settings.loinDepthThicknessInMillimeters'
              | translate
          }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="0.01"
            placeholder="{{
              'feed-profit.settings.extended-baseline-settings.loinDepthThicknessInMillimeters'
                | translate
            }}"
            data-test="feedprofit-settings__loinDepthThicknessInMillimeters"
            formControlName="loinDepthThicknessInMillimeters"
          />
        </mat-form-field>
        <mat-form-field class="flex__child--auto">
          <mat-label>{{
            'feed-profit.settings.extended-baseline-settings.backFatThicknessInMillimeters'
              | translate
          }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="0.01"
            placeholder="{{
              'feed-profit.settings.extended-baseline-settings.backFatThicknessInMillimeters'
                | translate
            }}"
            data-test="feedprofit-settings__backFatThicknessInMillimeters"
            formControlName="backFatThicknessInMillimeters"
          />
        </mat-form-field>
        <mat-form-field class="flex__child--auto">
          <mat-label>{{
            'feed-profit.settings.extended-baseline-settings.growth' | translate
          }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="0.01"
            placeholder="{{ 'feed-profit.settings.extended-baseline-settings.growth' | translate }}"
            data-test="feedprofit-settings__growth"
            formControlName="growth"
          />
        </mat-form-field>
        <mat-form-field class="flex__child--auto">
          <mat-label>{{
            'feed-profit.settings.extended-baseline-settings.averageEnergyConversion' | translate
          }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="0.01"
            placeholder="{{
              'feed-profit.settings.extended-baseline-settings.averageEnergyConversion' | translate
            }}"
            data-test="feedprofit-settings__averageEnergyConversion"
            formControlName="averageEnergyConversion"
          />
        </mat-form-field>
        <mat-form-field class="flex__child--auto">
          <mat-label>{{
            'feed-profit.settings.extended-baseline-settings.mortalityPercentage' | translate
          }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="0.01"
            placeholder="{{
              'feed-profit.settings.extended-baseline-settings.mortalityPercentage' | translate
            }}"
            data-test="feedprofit-settings__mortalityPercentage"
            formControlName="mortalityPercentage"
          />
        </mat-form-field>
        <mat-form-field class="flex__child--auto">
          <mat-label>{{
            'feed-profit.settings.extended-baseline-settings.cleaning' | translate
          }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="0.01"
            placeholder="{{
              'feed-profit.settings.extended-baseline-settings.cleaning' | translate
            }}"
            data-test="feedprofit-settings__cleaning"
            formControlName="cleaning"
          />
        </mat-form-field>
        <mat-form-field class="flex__child--auto">
          <mat-label>{{
            'feed-profit.settings.extended-baseline-settings.fertilizerPerGrowFinisherInCubicMeters'
              | translate
          }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="0.001"
            placeholder="{{
              'feed-profit.settings.extended-baseline-settings.fertilizerPerGrowFinisherInCubicMeters'
                | translate
            }}"
            data-test="feedprofit-settings__fertilizerPerGrowFinisherInCubicMeters"
            formControlName="fertilizerPerGrowFinisherInCubicMeters"
          />
        </mat-form-field>
        <mat-form-field class="flex__child--auto">
          <mat-label>{{
            'feed-profit.settings.extended-baseline-settings.fertilizerPricePerCubicMeter'
              | translate
          }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="0.01"
            placeholder="{{
              'feed-profit.settings.extended-baseline-settings.fertilizerPricePerCubicMeter'
                | translate
            }}"
            data-test="feedprofit-settings__fertilizerPricePerCubicMeter"
            formControlName="fertilizerPricePerCubicMeter"
          />
        </mat-form-field>
      </div>

      <div class="spacing--margin-vertical">
        <span class="text--small text--h5 label">
          {{ 'feed-profit.settings.extended-baseline-settings.deliveries' | translate }}
        </span>
        <div class="flex--row flex--nowrap flex--justify-end">
          <div class="flex--column spacing--margin-horizontal">
            <mat-form-field class="flex__child--auto">
              <mat-label>{{
                'feed-profit.settings.extended-baseline-settings.1st-delivery-percentage'
                  | translate
              }}</mat-label>
              <input
                matInput
                agrNumber
                [step]="0.01"
                placeholder="{{
                  'feed-profit.settings.extended-baseline-settings.1st-delivery-percentage'
                    | translate
                }}"
                data-test="feedprofit-settings__1st-delivery-percentage"
                formControlName="firstDeliveryPercentage"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="flex--row flex--nowrap flex--justify-space-between">
          <div class="flex--column spacing--margin-horizontal">
            <mat-form-field class="flex__child--auto">
              <mat-label>{{
                'feed-profit.settings.extended-baseline-settings.days' | translate
              }}</mat-label>
              <input
                matInput
                agrNumber
                [step]="1"
                placeholder="{{
                  'feed-profit.settings.extended-baseline-settings.days' | translate
                }}"
                data-test="feedprofit-settings__2nd-delivery-days"
                formControlName="secondDeliveryDays"
              />
            </mat-form-field>
          </div>
          <div class="flex--column spacing--margin-horizontal">
            <mat-form-field class="flex__child--auto">
              <mat-label>{{
                'feed-profit.settings.extended-baseline-settings.2nd-delivery-percentage'
                  | translate
              }}</mat-label>
              <input
                matInput
                agrNumber
                [step]="0.01"
                placeholder="{{
                  'feed-profit.settings.extended-baseline-settings.2nd-delivery-percentage'
                    | translate
                }}"
                data-test="feedprofit-settings__2nd-delivery-percentage"
                formControlName="secondDeliveryPercentage"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="flex--row flex--nowrap flex--justify-space-between">
          <div class="flex--column spacing--margin-horizontal">
            <mat-form-field class="flex__child--auto">
              <mat-label>{{
                'feed-profit.settings.extended-baseline-settings.days' | translate
              }}</mat-label>
              <input
                matInput
                agrNumber
                [step]="1"
                placeholder="{{
                  'feed-profit.settings.extended-baseline-settings.days' | translate
                }}"
                data-test="feedprofit-settings__3rd-delivery-days"
                formControlName="thirdDeliveryDays"
              />
            </mat-form-field>
          </div>
          <div class="flex--column spacing--margin-horizontal">
            <span class="text--small text--gray third-delivery-percentage">
              {{
                'feed-profit.settings.extended-baseline-settings.3rd-delivery-percentage'
                  | translate
              }}
            </span>
            <span
              class="text--small text--bold"
              data-test="feedprofit-settings__3rd-delivery-percentage"
            >
              {{ thirdDeliveryPercentage$ | async }}%
            </span>
          </div>
        </div>
        <div *ngIf="invalidPercentages" class="validation-error">
          {{ 'feed-profit.settings.extended-baseline-settings.invalid-percentages' | translate }}
        </div>
      </div>

      <mat-divider></mat-divider>

      <div class="spacing--margin-vertical">
        <span class="text--small text--h5 label">
          {{ 'feed-profit.settings.extended-baseline-settings.vc-label' | translate }}
        </span>
        <div class="spacing--margin-top">
          <table>
            <thead>
              <tr>
                <th></th>
                <th class="text--small text--gray">
                  {{
                    'feed-profit.settings.extended-baseline-settings.vc-table-header-ewc'
                      | translate
                  }}
                </th>
                <th class="text--small text--gray">
                  {{
                    'feed-profit.settings.extended-baseline-settings.vc-table-header-ew' | translate
                  }}
                </th>
                <th class="text--small text--gray">
                  {{
                    'feed-profit.settings.extended-baseline-settings.vc-table-header-feed'
                      | translate
                  }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text--small text--gray first-col">
                  {{
                    'feed-profit.settings.extended-baseline-settings.vc-table-col-low-kg'
                      | translate
                  }}
                </td>
                <td class="text--small text--bold">
                  {{
                    roundEnergyValue(
                      getEnergyConversionValues(energyTypes.startLessThan25, calculation)
                    )
                  }}
                </td>
                <td class="text--small text--bold">
                  {{
                    roundEnergyValue(getEnergyGiftValues(energyTypes.startLessThan25, calculation))
                  }}
                </td>
                <td class="text--small text--bold">
                  {{
                    roundEnergyValue(getFeedGiftValues(energyTypes.startLessThan25, calculation))
                  }}
                </td>
              </tr>
              <tr>
                <td class="text--small text--gray first-col">
                  {{
                    'feed-profit.settings.extended-baseline-settings.vc-table-col-high-kg'
                      | translate
                  }}
                  {{
                    calculation?.genders
                      ? ('feed-profit.genders.' + calculation?.genders | translate)
                      : ''
                  }}
                </td>
                <td class="text--small text--bold">
                  {{
                    roundEnergyValue(getEnergyConversionValues(energyTypes.endBoar, calculation))
                  }}
                </td>
                <td class="text--small text--bold">
                  {{ roundEnergyValue(getEnergyGiftValues(energyTypes.endBoar, calculation)) }}
                </td>
                <td class="text--small text--bold">
                  {{ roundEnergyValue(getFeedGiftValues(energyTypes.endBoar, calculation)) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </form>
</div>
